import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import dayjs from 'dayjs';
import { Component } from "preact";
export class RemainingTime extends Component {
    constructor(props) {
        super(props);
        this.state = {
            remainMillSec: 0,
        };
    }
    componentDidMount() {
        // 終了日時を取得
        const { endDatetime, extendedEndDatetime } = this.props;
        if (endDatetime) {
            const endTime = dayjs(extendedEndDatetime ? extendedEndDatetime : endDatetime);
            const now = dayjs();
            let remain = endTime.diff(now, "milliseconds");
            this.setState({ remainMillSec: remain });
            if (remain > 0) {
                setInterval(() => {
                    remain = remain - 1000;
                    this.setState({ remainMillSec: remain });
                }, 1000);
            }
        }
    }
    render() {
        return (_jsx(_Fragment, { children: this.calcRemainDateTime() }, void 0));
    }
    calcRemainDateTime() {
        const millsec = this.state.remainMillSec;
        if (millsec <= 0) {
            return "-";
        }
        const day = Math.floor(millsec / (24 * 60 * 60 * 1000));
        const hour = ("0" + Math.floor(millsec / (60 * 60 * 1000) % 24)).slice(-2);
        const minutes = ("0" + Math.floor(millsec / (60 * 1000) % 60)).slice(-2);
        const second = ("0" + Math.floor(millsec / 1000 % 60)).slice(-2);
        if (day > 0) {
            return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ class: "is-size-6" }, { children: day }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u65E5" }), void 0),
                    _jsx("span", Object.assign({ class: "is-size-6" }, { children: hour }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u6642" }), void 0),
                    _jsx("span", Object.assign({ class: "is-size-6" }, { children: minutes }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u5206" }), void 0),
                    _jsx("span", Object.assign({ class: "is-size-6" }, { children: second }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u79D2" }), void 0)] }, void 0));
        }
        return (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({ class: "is-size-6" }, { children: hour }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u6642" }), void 0),
                _jsx("span", Object.assign({ class: "is-size-6" }, { children: minutes }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u5206" }), void 0),
                _jsx("span", Object.assign({ class: "is-size-6" }, { children: second }), void 0), _jsx("span", Object.assign({ class: "is-size-7" }, { children: "\u79D2" }), void 0)] }, void 0));
    }
}
